module.exports = __webpack_public_path__ + "static/bunnyvelour-c26f837de67957987778db7ff32c38bd.jpeg";